import { gql } from "@apollo/client";

export const GET_GAMES = gql`
  fragment GameFields on GameType {
    id
    awards {
      id
      displayTitle
      category {
        source {
          awardName
          sourceName
        }
      }
    }
    cacheKey
    closingAt
    communityRatingCount
    communityScoreBucket
    communityScorePercentages {
      percentage
      rating
    }
    coupons(limit: 1) {
      id
    }
    description
    difficulty
    gameimageSet {
      order
      imageId
    }
    hasAwards
    hasBookings
    isCompleted @include(if: $isUser)
    isPromoted
    isScary
    isSaved @include(if: $isUser)
    kind
    gameLocation: location {
      company {
        id
        name
        slug
      }
      displayName
      id
      slug
    }
    name
    minutes
    openingAt
    overallRating @include(if: $isUser)
    playersMax
    playersMin
    primaryCategory {
      id
      name
      slug
      parent {
        id
        name
        slug
      }
    }
    promotedBidId
    secondaryCategories {
      id
      name
      slug
    }
    slug
    status
    tags {
      id
    }
    timeslots(limit: 10) {
      datetime
      available
    }
  }

  fragment LocationFields on LocationType {
    id
    cacheKey
    company {
      id
      name
      slug
    }
    displayName
    games {
      ...GameFields
    }
    locality {
      locality
      region
    }
    slug
  }

  query Games(
    $boundingBox: CoordinateBoundingBox
    $distance: Int
    $escapedOnly: Boolean
    $excludeNotPlayed: Boolean
    $excludePlayed: Boolean
    $excludeSaved: Boolean
    $filters: GameFiltersInput
    $groupByLocation: Boolean
    $includeAllGames: Boolean
    $isUser: Boolean!
    $lat: Float
    $lng: Float
    $page: Int
    $pageSize: Int
    $query: String
    $savedOnly: Boolean
    $sortBy: GameSortByOptions
    $userId: ID
    $userIds: [ID]
    $client: String
  ) {
    games(
      boundingBox: $boundingBox
      distance: $distance
      escapedOnly: $escapedOnly
      excludeNotPlayed: $excludeNotPlayed
      excludePlayed: $excludePlayed
      excludeSaved: $excludeSaved
      filters: $filters
      groupByLocation: $groupByLocation
      includeAllGames: $includeAllGames
      lat: $lat
      lng: $lng
      page: $page
      pageSize: $pageSize
      query: $query
      savedOnly: $savedOnly
      sortBy: $sortBy
      userId: $userId
      userIds: $userIds
      client: $client
    ) {
      count
      hasNext
      page
      pages
      objects {
        ...GameFields
        ...LocationFields
      }
    }
  }
`;
